import React, { useState, forwardRef } from 'react';
import loader from "../assets/svg/candlestick.gif"
import {
    Modal,
    Box,
    Typography,
} from '@mui/material';
const MyLodder = ({ canShow, message
}) => {

    return (

        <Modal
            open={canShow}
            sx={{ border: 'none' }}>
            <Box
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 'auto',
                    outline: 'none',
                    background: 'transparent',
                    padding: '20px',
                    borderRadius: '12px',
                    display: 'flex',
                    flexDirection: 'column',   // 🔥 THIS MAKES TEXT COME BELOW GIF
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px',               // spacing between GIF and text
                }}
            >
                <img src={loader} height={150} />

                {message && (
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'white',
                            fontSize: '1rem',
                            fontWeight: 500,
                            textAlign: 'center',   // center align text
                            whiteSpace: 'pre-line'
                        }}
                    >
                        {message}
                    </Typography>
                )}
            </Box>


        </Modal>


    );
};
export default MyLodder;
